// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1rwN6","insightsList":"newBusinessInsightsMenu_insightsList__226b5","active":"newBusinessInsightsMenu_active__2jX46"};